function canAward({ offers }) {
  return (
    offers.filter(
      (o) => o.isValid && ['confirmed', 'accepted'].includes(o.status)
    ).length > 0
  );
}

function canConfirmAward({ offers }) {
  return (
    offers.filter((o) => o.status === 'awarded').length > 0 &&
    offers.filter((o) => ['confirmed', 'accepted'].includes(o.status)).length >
      0
  );
}

const actionSelector = ({ sale, round }) => {
  const { type, status } = round;
  let actions = [];
  if (sale.hasSalePermissions) {
    actions = [...actions, 'duplicate'];
    if (status === 'closed' || type === 'simple_offer') {
      if (type === 'sealed_bidding') {
        actions = [...actions, 'counteroffer', 'increase'];
      }
      if (type === 'open_bidding') {
        actions = [...actions];
      }
      if (type === 'counteroffer_bidding') {
        actions = [...actions, 'counteroffer'];
      }
      if (type === 'simple_offer') {
        actions = [...actions, 'increase'];
      }
      if (canAward({ offers: sale.offers.viewModel.offers })) {
        if (sale.round.definition.type === 'registration')
          actions = [...actions, 'awardAll'];
        else actions = [...actions, 'award', 'rejectAll'];
      }

      if (canConfirmAward({ offers: sale.offers.viewModel.offers })) {
        actions = [...actions, 'confirmAward', 'rejectAll'];
      }
    }
  } else {
    if (sale.offers.hasAccessibleOffers) actions = [...actions, 'notifySeller'];
  }
  const saleActions = sale.saleConfig.saleActions.map((name) => ({
    name,
  }));
  return saleActions.filter((a) => actions.includes(a.name)).map((a) => a.name);
};

export default actionSelector;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/stores/actionSelector.js